
var drawer = function () {
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }
      Element.prototype.closest = function (s) {
        var el = this;
        var ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
          if (ancestor.matches(s)) return ancestor;
          ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
      };
    }
    var settings = {
      speedOpen: 50,
      speedClose: 350,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',

    };


    var toggleccessibility = function (event) {
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    };


    var openDrawer = function (trigger) {
      var target = document.getElementById(trigger.getAttribute('aria-controls'));
      target.classList.add(settings.activeClass);
      document.documentElement.style.overflow = 'hidden';
      toggleccessibility(trigger);


      setTimeout(function () {
        target.classList.add(settings.visibleClass);
      }, settings.speedOpen);
    };

    var closeDrawer = function (event) {
      var closestParent = event.closest(settings.selectorTarget),
        childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
      closestParent.classList.remove(settings.visibleClass);
      document.documentElement.style.overflow = '';
      toggleccessibility(childrenTrigger);
      setTimeout(function () {
        closestParent.classList.remove(settings.activeClass);
      }, settings.speedClose);
    };
    var clickHandler = function (event) {
         var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        close = toggle.closest(settings.selectorClose);
    var has_form =   event.target.closest(".form.so-product-form") ;
   if(has_form){
   
    event.preventDefault();
    $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: $(has_form).serialize(),
            dataType: 'json',
            success: function (data) {
               // alert('Submission was successful.');
               // alert(data.id);
                Shopify.getCart(function(response){
                  // alert(response);
                   if(response.items.length){
                     
                     var drawer_line_items = '<form id="em-drawer" action="/cart" method="post" novalidate="" class="cart-content-wrapper cart-drawer"><ul class="cart-item-wrapper">';
                     response.items.forEach(added_item => {
                       var linked_gift_id = "";
                       if(added_item.properties){
                         if(added_item.properties.hasOwnProperty("_Addon | Assigned with") && added_item.properties.hasOwnProperty("_gift_note_variant_id")){
                           linked_gift_id = added_item.properties._gift_note_variant_id;
                         }
                       }
                       
                       drawer_line_items += `<li> <div class="ci-left"> <a href="${added_item.url}" class="item-img"><img src="${added_item.featured_image.url}" alt="img"></a> <div class="ci-content"> <h4>${added_item.product_title}</h4><span>${(added_item.variant_title && added_item.variant_title != "Default Title") ? added_item.variant_title : ''}</span>  <div class="qtybox"> <span class="btnqty qtyminus icon icon-minus">-</span> <input type="text" id="quantity" name="quantity" value="${added_item.quantity}" min="1" class="quantity-selector quantity-input" readonly=""> <span class="btnqty qtyplus icon icon-plus">+</span> </div> </div> </div> <div class="ci-right"> <div class="price"> <strong>${Shopify.formatMoney(added_item.final_line_price)}</strong> </div> <button class="remove-btn" type="button" data-v-id="${added_item.variant_id}" data-gift-id="${linked_gift_id}"> Remove </button> </div> </li>`;
                     });
                     drawer_line_items += `</ul><div class="total-amount"> <div class="total">Total <strong>${Shopify.formatMoney(response.total_price)}</strong></div> </div> <button id="checkoutBtn" type="submit" name="checkout"> Proceed To Checkout  ( ${response.item_count} Items) </button></form>`;
                     $('.empty-cart').remove();
                     $('#em-drawer').remove();
                     $(drawer_line_items).insertAfter( ".drawer__header" );
                     openDrawer(open);
                   }
                });
            },
            error: function (data) {
                alert('An error occurred.');
                //alert(data.id);
            },
        });
    
     
     return;
   }
   
   


      if (open) { openDrawer(open); }
      if (close) { closeDrawer(close); }
      if (open || close) { event.preventDefault(); }
    };


    var keydownHandler = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        var drawers = document.querySelectorAll(settings.selectorTarget),
          i;
        for (i = 0; i < drawers.length; ++i) {
          if (drawers[i].classList.contains(settings.activeClass)) {
            closeDrawer(drawers[i]);
          }
        }
      }
    };


    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);
};

drawer();




$(document).on('click','.remove-btn', function() {

  
  var variant_id =  $(this).data("v-id");
  var gift_id = $(this).data("gift-id");
  var data_update =  {
          [variant_id]:0
        
        };
  if(gift_id){
    data_update[gift_id] = 0;
  }
  $.ajax({
      url: '/cart/update.js',
      data: {
        updates : data_update
      },
      dataType:"json",
      type: 'POST',
      success: function (response) {
    	 if(response.items.length){
                     var drawer_line_items = '<form id="em-drawer" action="/cart" method="post" novalidate="" class="cart-content-wrapper cart-drawer"><ul class="cart-item-wrapper">';
                     response.items.forEach(added_item => {
                       drawer_line_items += `<li> <div class="ci-left"> <a href="${added_item.url}" class="item-img"><img src="${added_item.featured_image.url}" alt="img"></a> <div class="ci-content"> <h4>${added_item.product_title}</h4><span>${(added_item.variant_title && added_item.variant_title != "Default Title") ? added_item.variant_title : ''}</span>  <div class="qtybox"> <span class="btnqty qtyminus icon icon-minus">-</span> <input type="text" id="quantity" name="quantity" value="${added_item.quantity}" min="1" class="quantity-selector quantity-input" readonly=""> <span class="btnqty qtyplus icon icon-plus">+</span> </div> </div> </div> <div class="ci-right"> <div class="price"> <strong>${Shopify.formatMoney(added_item.final_line_price)}</strong> </div> <button class="remove-btn" type="button" data-v-id="${added_item.variant_id}"> Remove </button> </div> </li>`;
                     });
                       drawer_line_items += `</ul><div class="total-amount"> <div class="total">Total <strong>${Shopify.formatMoney(response.total_price)}</strong></div> </div> <button id="checkoutBtn" type="submit" name="checkout"> Proceed To Checkout  ( ${response.item_count} Items) </button></form>`;
                     $('.empty-cart').remove();
                     $('#em-drawer').remove();
                     $(drawer_line_items).insertAfter( ".drawer__header" );
                    
        }
        else{
            var empty_drawer_html= '<div class="empty-cart"> <strong>Your Cart Is Empty</strong> </div>';
            $('.empty-cart').remove();
            $('#em-drawer').remove();
            $(empty_drawer_html).insertAfter( ".drawer__header" );
        }
      }
     });
  
});



$(document).on('click','.qtybox .btnqty', function(){
 

  var variant_id  = $(this).closest("li").find(".remove-btn").data("v-id");
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
      qty++;
      
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
   $.ajax({
      url: '/cart/update.js',
      data: {
        updates : {
          [variant_id]: qty
        
        }
      },
      dataType:"json",
      type: 'POST',
      success: function (response) {
    	 if(response.items.length){
                     var drawer_line_items = '<form id="em-drawer" action="/cart" method="post" novalidate="" class="cart-content-wrapper cart-drawer"><ul class="cart-item-wrapper">';
                     response.items.forEach(added_item => {
                       drawer_line_items += `<li> <div class="ci-left"> <a href="${added_item.url}" class="item-img"><img src="${added_item.featured_image.url}" alt="img"></a> <div class="ci-content"> <h4>${added_item.product_title}</h4><span>${(added_item.variant_title && added_item.variant_title != "Default Title") ? added_item.variant_title : ''}</span>  <div class="qtybox"> <span class="btnqty qtyminus icon icon-minus">-</span> <input type="text" id="quantity" name="quantity" value="${added_item.quantity}" min="1" class="quantity-selector quantity-input" readonly=""> <span class="btnqty qtyplus icon icon-plus">+</span> </div> </div> </div> <div class="ci-right"> <div class="price"> <strong>${Shopify.formatMoney(added_item.final_line_price)}</strong> </div> <button class="remove-btn" type="button" data-v-id="${added_item.variant_id}"> Remove </button> </div> </li>`;
                     });
                     drawer_line_items += `</ul><div class="total-amount"> <div class="total">Total <strong>${Shopify.formatMoney(response.total_price)}</strong></div> </div> <button id="checkoutBtn" type="submit" name="checkout"> Proceed To Checkout  ( ${response.item_count} Items) </button></form>`;
                     $('.empty-cart').remove();
                     $('#em-drawer').remove();
                     $(drawer_line_items).insertAfter( ".drawer__header" );
                    
        }
       
      }
     });
      $(this).parent('.qtybox').find('.quantity-input').val(qty);
      

  
  }); 

